<template>
  <app-layout>
    <div
        class="bg-white lg:shadow-lg p-6 lg:py-12 lg:px-16 mx-auto lg:max-w-4xl lg:mt-20 flex flex-1 lg:flex-grow-0 flex-wrap justify-center">
      <h2 class="w-full capitalize text-center mb-8 text-dark-blue">{{ $trans('app.create-account') }}</h2>

      <jet-validation-errors class="w-full text-center mb-8"/>

      <form @submit.prevent="submit">
        <div>
          <jet-label for="email" value="Email"/>
          <jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus/>
        </div>

        <div class="mt-4">
          <jet-label for="password" :value="$trans('app.password')"/>
          <jet-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" required
                     autocomplete="new-password"/>
        </div>

        <div class="mt-4">
          <jet-label for="password_confirmation" :value="$trans('app.confirm-password')"/>
          <jet-input id="password_confirmation" type="password" class="mt-1 block w-full"
                     v-model="form.password_confirmation" required autocomplete="new-password"/>
        </div>

        <div class="flex items-center justify-end mt-4">
          <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
            {{ $trans('app.create-account') }}
          </jet-button>
        </div>
      </form>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'
import JetValidationErrors from '@/Jetstream/ValidationErrors'

export default {
  components: {
    AppLayout,
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetButton,
    JetInput,
    JetLabel,
    JetValidationErrors
  },

  props: {
    email: String,
    token: String,
  },

  data() {
    return {
      form: this.$inertia.form({
        token: this.token,
        email: this.email,
        password: '',
        password_confirmation: '',
      })
    }
  },

  methods: {
    submit() {
      this.form.post(this.route('password.update'), {
        onFinish: () => this.form.reset('password', 'password_confirmation'),
      })
    }
  }
}
</script>
